import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import * as httpClient from "../../../util/httpClient";
import { updateState, states } from "../StateManagement";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { Notification } from "../../common/Notification";
import { useTranslation } from "react-i18next";
import PhoneInput, { parsePhoneNumber } from "react-phone-number-input";
import { isValidPhoneNo } from "../../../util/phoneNumberValidationUtil";
import { useButtonText } from "../../commonConstants";
import { ApplicationState } from "../../../store";
interface IProps {
    displayData: any;
    manageState: any;
    registrationState: any;
    setRegistrationState: any;
}

const TwoFactorMFAForm = ({ displayData, manageState, registrationState, setRegistrationState }: IProps) => {
    const { register, handleSubmit, errors, watch, control } = useForm({
        mode: "onTouched",
        criteriaMode: "all",
    });
    let history = useHistory();
    const { t: tLang } = useTranslation();
    const query = new URLSearchParams(useLocation().search);
    const retailerCode: any = query.get('RetailerCode') || query.get('RETAILERCODE');
    const [state, setState] = useState({
        code: "",
        enterCode: true,
        submitCode: false,
        errorMessage: "",
        maximumAttemptReached: false,
        SuccessfulCode: false,
        isDisable: true,
        isLoading: false,
        deliverMethod:
            registrationState.twoFactorMFA && Object.keys(registrationState.twoFactorMFA).length !== 0 && registrationState.twoFactorMFA.deliverMethod
                ? registrationState.twoFactorMFA.deliverMethod
                : "",
        phoneNumber:
            registrationState.twoFactorMFA && Object.keys(registrationState.twoFactorMFA).length !== 0 && registrationState.twoFactorMFA.phoneNumber
                ? registrationState.twoFactorMFA.phoneNumber
                : registrationState.personalInfo.phoneNumber,
        MfaSmsNumber:
            registrationState.twoFactorMFA && Object.keys(registrationState.twoFactorMFA).length !== 0 && registrationState.twoFactorMFA.MfaSmsNumber
                ? registrationState.twoFactorMFA.MfaSmsNumber
                : registrationState.personalInfo.phoneNumber,
        MfaVoiceCallNumber:
            registrationState.twoFactorMFA && Object.keys(registrationState.twoFactorMFA).length !== 0 && registrationState.twoFactorMFA.MfaVoiceCallNumber
                ? registrationState.twoFactorMFA.MfaVoiceCallNumber
                : registrationState.personalInfo.phoneNumber,
        PersonalCountry:
            registrationState.addressInfo && Object.keys(registrationState.addressInfo).length !== 0 && registrationState.addressInfo.country
                ? registrationState.addressInfo.country
                : "US",
    });

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const [isNextOrContinue, isPreviousOrBack] = useButtonText();
    const isTUPartner = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2649
                ? true
                : false
            : false
    );
    const setCommMethod = (e: any) => {
        setState({
            ...state,
            [e.target.name]: e.target.value,
        });
    };

    const setCode = (e: any) => {
        setState({
            ...state,
            [e.target.name]: e.target.value,
        });
    };

    const submitCode = () => {
        const requestBody = {
            SecurityCode: state.code,
        };

        httpClient.sendRequest("POST", "web/Registration/VerifyRegistrationMFA", requestBody).then((data: any) => {
            if (data && data["isSuccess"]) {
                if (state.deliverMethod === "1") {
                    setRegistrationState({ ...registrationState, twoFactorMFA: { ...state, MfaVoiceCallNumber: null } });
                }
                if (state.deliverMethod === "3") {
                    setRegistrationState({ ...registrationState, twoFactorMFA: { ...state, MfaSmsNumber: null } });
                }
                if (state.deliverMethod === "0") {
                    setRegistrationState({ ...registrationState, twoFactorMFA: { ...state, MfaVoiceCallNumber: null, MfaSmsNumber: null } });
                }
                manageState(updateState(states, displayData.billingRequired, 5));
                return;
            }
            if (data && data["maximumAttemptReached"]) {
                setState({ ...state, maximumAttemptReached: true, submitCode: false, SuccessfulCode: false, enterCode: true, errorMessage: "" });
                setRegistrationState({
                    ...registrationState,
                    twoFactorMFA: { ...state, maximumAttemptReached: true, MfaVoiceCallNumber: null, MfaSmsNumber: null },
                });
                return;
            }
            if (data && data["hasError"]) {
                if (data && data.status) {
                    switch (data.status) {
                        case "INTERNAL_ERROR":
                            history.push("/register/error");
                            break;
                        default:
                            history.push("/register/error");
                            break;
                    }
                } else {
                    setState({ ...state, errorMessage: tLang("registration.authentication.validationMessage.validationCode.invalid") });
                }
            }
        });
    };

    const resendCode = () => {
        setState((prevState) => ({ ...prevState, submitCode: false, SuccessfulCode: false, enterCode: true, errorMessage: "", isDisable: true }));
    };

    const onSubmit = (data1: any) => {
        if (state.submitCode) {
            return;
        }
        setState({ ...state, isLoading: true, errorMessage: "" });
        let number =
            state.deliverMethod === "1"
                ? getCountryInfo()
                    ? data1.MfaSmsNumber.replace(/[^0-9+]/g, "")
                    : data1.MfaSmsNumber
                : state.deliverMethod === "3"
                ? getCountryInfo()
                    ? data1.MfaVoiceCallNumber.replace(/[^0-9+]/g, "")
                    : data1.MfaVoiceCallNumber
                : getCountryInfo()
                ? registrationState.personalInfo.phoneNumber.replace(/[^0-9+]/g, "")
                : registrationState.personalInfo.phoneNumber;
        const requestBody = {
            mfaNotificationMethod: Number(state.deliverMethod),
            emailId: registrationState.personalInfo.email,
            personalPhoneNo: number,
            PersonalCountry: state.PersonalCountry,
        };

        httpClient.sendRequest("POST", "web/Registration/send-mfa-secureCode", requestBody).then((data: any) => {
            if (data && data["isSuccess"]) {
                setState({
                    ...state,
                    submitCode: true,
                    SuccessfulCode: false,
                    enterCode: false,
                    isDisable: false,
                    isLoading: false,
                    MfaSmsNumber: data1.MfaSmsNumber ? data1.MfaSmsNumber : registrationState.personalInfo.phoneNumber,
                    MfaVoiceCallNumber: data1.MfaVoiceCallNumber ? data1.MfaVoiceCallNumber : registrationState.personalInfo.phoneNumber,
                });
                return;
            }
            if (data && data["hasError"]) {
                setState({ ...state, isLoading: false });

                Notification({
                    type: "error",
                    title: tLang("registration.authentication.errorNotification.title"),
                    message: tLang("registration.authentication.errorNotification.message"),
                    duration: 5,
                });
            }
            setState({ ...state, isLoading: false });
        });
        window.addToDataLayer({ event: "Submit Two Factor MFA Form" });
    };

    const setPrevious = () => {
        manageState(updateState(states, displayData.billingRequired, 3));
    };

    const getCountryInfo = () => {
        let currentCountry = registrationState && registrationState.addressInfo ? registrationState.addressInfo.country : "";
        if (currentCountry.includes("US") || currentCountry.includes("CA")) {
            return false;
        } else {
            return true;
        }
    };

    useEffect(() => {
        const el = document.getElementsByClassName("PhoneInputCountry");
        if (el && el.length > 0) {
            try {
                const childs = el[0].children;
                if (childs[0].nodeName === "SELECT") {
                    const selectEl = childs[0] as HTMLSelectElement;
                    selectEl.disabled = true;
                }
            } catch {}
        }
    }, [state.deliverMethod]);

    return (
        <div className={state.isLoading ? "box-content loading" : "box-content"}>
            <form id="form-MFA" onSubmit={handleSubmit(onSubmit)}>
                <div className="row between-sm">
                    <div className="col-xs-12  col-no-gutter">
                        <p>{tLang("registration.authentication.message")}</p>
                        <div className="margin-bottom-l"></div>
                    </div>
                </div>

                <div className="col-xs-12 col-sm-12 col-no-gutter">
                    <fieldset className="form-row inline">
                        <div className="row">
                            <div className={`form-row inline row}`}>
                                <div className="form-label col-xs-12 col-sm-3 col-no-gutter">
                                    <label htmlFor="label-account-type">{tLang("registration.authentication.label.deliveryMethod")}</label>
                                </div>
                                <div className="form-input col-xs-12 col-sm-5 col-no-gutter">
                                    <select
                                        className="inputbox"
                                        id="label-account-type"
                                        ref={register({ required: true })}
                                        defaultValue={state.deliverMethod}
                                        name="deliverMethod"
                                        onChange={(e) => setCommMethod(e)}
                                    >
                                        <option value="">{tLang("registration.authentication.deliveryMethodDropDown.option1")}</option>
                                        <option value="0">{tLang("registration.authentication.deliveryMethodDropDown.option2")}</option>
                                        <option value="1">{tLang("registration.authentication.deliveryMethodDropDown.option3")}</option>
                                        <option value="3">{tLang("registration.authentication.deliveryMethodDropDown.option4")}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                    {state.deliverMethod === "0" && (
                        <fieldset className="form-row inline">
                            <div className="row">
                                <div className={`form-row inline row}`}>
                                    <div className="form-label col-xs-12 col-sm-3 col-no-gutter">
                                        <label htmlFor="label-rounting-number">{tLang("registration.authentication.label.email")}</label>
                                    </div>
                                    <div className="form-label col-xs-12 col-sm-5 col-no-gutter">
                                        <label htmlFor="label-rounting-number">{registrationState.personalInfo.email}</label>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    )}
                    {state.deliverMethod === "1" && (
                        <fieldset className="form-row inline">
                            <div className="row">
                                <div
                                    className={`form-row row inline ${errors["MfaSmsNumber"] && "status-error"} ${
                                        errors["MfaSmsNumber"] && watch("MfaSmsNumber") && !parsePhoneNumber(watch("MfaSmsNumber")) ? "country-error" : ""
                                    }`}
                                >
                                    <div className="form-label col-xs-12 col-sm-3 col-no-gutter">
                                        <label htmlFor="label-phone-number1">{tLang("registration.authentication.label.phone-number")}</label>
                                    </div>
                                    <div className="form-input col-xs-12 col-sm-5 col-no-gutter">
                                        <Controller
                                            name={"MfaSmsNumber"}
                                            control={control}
                                            defaultValue={state.MfaSmsNumber ? state.MfaSmsNumber : ""}
                                            className="inputbox"
                                            rules={{
                                                required: true,
                                                validate: (value) =>
                                                    value
                                                        ? isValidPhoneNo(
                                                              registrationState.addressInfo.country ? registrationState.addressInfo.country : "US",
                                                              value
                                                          )
                                                        : false,
                                            }}
                                            render={({ onChange, value }) => (
                                                <PhoneInput
                                                    value={value}
                                                    onChange={onChange}
                                                    international={false}
                                                    addInternationalOption={false}
                                                    defaultCountry={registrationState.addressInfo.country ? registrationState.addressInfo.country : "US"}
                                                    countries={[registrationState.addressInfo.country ? registrationState.addressInfo.country : "US"]}
                                                    id="label-phone-number1"
                                                    placeholder={tLang("registration.personalInfo1Widget.placeholder.mobile")}
                                                    maxLength={15}
                                                    minLength={10}
                                                />
                                            )}
                                        />
                                        {!!errors["MfaSmsNumber"] && errors["MfaSmsNumber"].type === "required" && (
                                            <span className="form-error">{tLang("registration.personalInfo1Widget.validationMessage.phone.requiredMobile")}</span>
                                        )}
                                        {!!errors["MfaSmsNumber"] && errors["MfaSmsNumber"].type === "validate" && (
                                            <span className="form-error">{tLang("registration.personalInfo1Widget.validationMessage.phone.validateMobile")}</span>
                                        )}
                                        {!!errors["MfaSmsNumber"] &&
                                            errors["MfaSmsNumber"].type === "minLength" &&
                                            (getCountryInfo() ? (
                                            <span className="form-error">{tLang("registration.personalInfo1Widget.validationMessage.phone.minLengthMobile1")}</span>
                                            ) : (
                                                <span className="form-error">{tLang("registration.personalInfo1Widget.validationMessage.phone.minLengthMobile2")}</span>
                                            ))}
                                        {!!errors["MfaSmsNumber"] &&
                                            errors["MfaSmsNumber"].type === "maxLength" &&
                                            (getCountryInfo() ? (
                                            <span className="form-error">{tLang("registration.personalInfo1Widget.validationMessage.phone.minLengthMobile3")}</span>
                                            ) : (
                                                <span className="form-error">{tLang("registration.personalInfo1Widget.validationMessage.phone.minLengthMobile2")}</span>
                                            ))}
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    )}
                    {state.deliverMethod === "3" && (
                        <fieldset className="form-row inline">
                            <div className="row">
                                <div
                                    className={`form-row row inline ${errors["MfaVoiceCallNumber"] && "status-error"} ${
                                        errors["MfaVoiceCallNumber"] && watch("MfaVoiceCallNumber") && !parsePhoneNumber(watch("MfaVoiceCallNumber"))
                                            ? "country-error"
                                            : ""
                                    }`}
                                >
                                    <div className="form-label col-xs-12 col-sm-3 col-no-gutter">
                                        <label htmlFor="label-phone-number2">{tLang("registration.authentication.label.phone-number")}</label>
                                    </div>
                                    <div className="form-input col-xs-12 col-sm-5 col-no-gutter">
                                        <Controller
                                            name={"MfaVoiceCallNumber"}
                                            control={control}
                                            defaultValue={state.MfaVoiceCallNumber ? state.MfaVoiceCallNumber : ""}
                                            className="inputbox"
                                            rules={{
                                                required: true,
                                                validate: (value) =>
                                                    value
                                                        ? isValidPhoneNo(
                                                              registrationState.addressInfo.country ? registrationState.addressInfo.country : "US",
                                                              value
                                                          )
                                                        : false,
                                            }}
                                            render={({ onChange, value }) => (
                                                <PhoneInput
                                                    value={value}
                                                    onChange={onChange}
                                                    international={false}
                                                    addInternationalOption={false}
                                                    defaultCountry={registrationState.addressInfo.country ? registrationState.addressInfo.country : "US"}
                                                    countries={[registrationState.addressInfo.country ? registrationState.addressInfo.country : "US"]}
                                                    id="label-phone-number2"
                                                    placeholder="Enter Phone number"
                                                    maxLength={15}
                                                    minLength={10}
                                                />
                                            )}
                                        />
                                        {!!errors["MfaVoiceCallNumber"] && errors["MfaVoiceCallNumber"].type === "required" && (
                                            <span className="form-error">{tLang("registration.personalInfo1Widget.validationMessage.phone.required")}</span>
                                        )}
                                        {!!errors["MfaVoiceCallNumber"] && errors["MfaVoiceCallNumber"].type === "validate" && (
                                            <span className="form-error">{tLang("registration.personalInfo1Widget.validationMessage.phone.validate")}</span>
                                        )}
                                        {!!errors["MfaVoiceCallNumber"] &&
                                            errors["MfaVoiceCallNumber"].type === "minLength" &&
                                            (getCountryInfo() ? (
                                                <span className="form-error">
                                                    {tLang("identityVault.monitoredInformation.personalInfoWidget.validationMessage.phoneMinlengthError")}
                                                </span>
                                            ) : (
                                                <span className="form-error">Invalid format. Phone Number must be 10 digits in length.</span>
                                            ))}
                                        {!!errors["MfaVoiceCallNumber"] &&
                                            errors["MfaVoiceCallNumber"].type === "maxLength" &&
                                            (getCountryInfo() ? (
                                                <span className="form-error">
                                                    {tLang("identityVault.monitoredInformation.personalInfoWidget.validationMessage.phoneMaxlengthError")}
                                                </span>
                                            ) : (
                                                <span className="form-error">Invalid format. Phone Number must be 10 digits in length.</span>
                                            ))}
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    )}
                </div>
                {(state.deliverMethod === "1" || state.deliverMethod === "0" || state.deliverMethod === "3") && (
                    <div className="row between-sm col-xs-12 col-sm-12 col-no-gutter">
                        <div className="col-xs-12 col-sm-3 col-no-gutter"></div>
                        <div className="col-xs-12 col-sm-9 col-no-gutter">
                            <p>{tLang("registration.authentication.instructionMessage")}</p>
                            <div className="margin-bottom-l"></div>
                        </div>
                    </div>
                )}
                {state.deliverMethod === "1" && (isTUPartner && retailerCode === "tuvip") && (
                    <div className="row between-sm col-xs-12 col-sm-12 col-no-gutter">
                        <div className="col-xs-12 col-sm-3 col-no-gutter"></div>
                        <div className="col-xs-12 col-sm-9 col-no-gutter">
                            <p>{tLang("registration.authentication.tuvipMessage")}</p>
                            <div className="margin-bottom-l"></div>
                        </div>
                    </div>
                )}
                {state.enterCode && (state.deliverMethod === "1" || state.deliverMethod === "0" || state.deliverMethod === "3") && (
                    <div className="row between-sm col-xs-12 col-sm-12 col-no-gutter">
                        <div className="col-xs-12 col-sm-3 col-no-gutter"></div>
                        <div className="col-xs-12 col-sm-9 col-no-gutter">
                            <button type="submit" className="btn-default btn-primary btn-min-width">
                                <span className="btn-text">{tLang("registration.authentication.sendCodeButtonText")}</span>
                            </button>
                        </div>
                    </div>
                )}

                {state.submitCode && (
                    <div className="col-xs-12 col-sm-12 col-no-gutter">
                        <fieldset className="form-row inline">
                            <div className="row">
                                <div className={`form-row inline row}`}>
                                    <div className="form-label col-xs-12 col-sm-3 col-no-gutter">
                                        <label htmlFor="label-code">Code</label>
                                    </div>
                                    <div className="form-input col-xs-12 col-sm-5 col-no-gutter margin-right-s">
                                        <input
                                            type="text"
                                            className="inputbox"
                                            id="label-code"
                                            onChange={(e) => setCode(e)}
                                            placeholder={tLang("registration.authentication.placeholder")}
                                            ref={register({ required: true })}
                                            name="code"
                                        />
                                    </div>
                                    {state.deliverMethod !== "" && (
                                        <div className="form-input col-xs-12 col-sm-3 col-no-gutter">
                                            <p>
                                                <span className="default_link" onClick={() => resendCode()}>
                                                    <a href="javascript:void(0)" className="default_link">
                                                        {tLang("registration.authentication.resendCodeLinkText")}
                                                    </a>
                                                </span>
                                            </p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </fieldset>
                    </div>
                )}

                {state.errorMessage.length > 0 && (
                    <div className="row between-sm col-xs-12 col-sm-12 col-no-gutter">
                        <div className="col-xs-12 col-sm-3 col-no-gutter"></div>
                        <div className="col-xs-12 col-sm-9 col-no-gutter">
                            <span className="required">{state.errorMessage}</span>
                        </div>
                    </div>
                )}
                <div className="margin-vertical-l"></div>

                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null"></div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <ul className="list-inline list-reset">
                            <li className="margin-left-s">
                                <button type="button" className="btn-default btn-default btn-min-width" onClick={() => setPrevious()}>
                                    <span className="btn-text">{isPreviousOrBack}</span>
                                </button>
                            </li>
                            <li className="margin-left-s">
                                <button type="button" onClick={() => submitCode()} className="btn-default btn-primary btn-min-width" disabled={state.isDisable}>
                                    <span className="btn-text">
                                        {state.enterCode ? isNextOrContinue : tLang("registration.submitButtonText")}
                                    </span>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default TwoFactorMFAForm;
